import React from 'react';
// import Banner from 'react-js-banner';
function Introduction() {
return (
<div class="idocs-content">
   <div class="row">
      <div class="col-md-12">
         <div style={{ color: "#fff !important", backgroundColor: "#263f91", height: "350px" }}>
         <h1 class="banner-text" style={{}}>
            Welcome<br />
            to Safexpay<br />
            Documentation
         </h1>
         <p style={{ color: "#fff", float: "left", paddingLeft: "140px", marginTop: "10px" }}>
         Welcome to the Safexpay developer documentation. <br />
         You will find help about safexpay products and APIs <br />
         that will help you start using our products quickly.
         </p>
         <img src={process.env.PUBLIC_URL + '/images/Arrow-Green.png'} alt="logo" style={{width: "21%" , 
         float: "right" , top: "5%", right: "20%", position: "absolute"}}/>
      </div>
   </div>
</div>
<div class="container">
   <div class="row">
      <div class="col-md-8">
         <section id="idocs_content">
            <h1>Introduction</h1>
            <hr />
            <p>
               Welcome to SafeXPay Payouts, the secure and convenient way to transfer funds in India. With the increasing adoption of technology and the government's push towards a cashless economy, more and more businesses are turning to digital payout solutions to manage their finances. Our payout solutions, including payment gateways, API integrations, and bulk payment options, help businesses automate the payout process, reducing the time and effort required to transfer funds to multiple beneficiaries. From salary payments to vendor payments, refunds to cashback offers, and the gig economy, our payout solutions cater to a wide range of use cases. Join the growing number of businesses that are choosing SafexPay Payouts to streamline their payout process and transfer funds securely and conveniently.
            </p>
         </section>
      </div>
   </div>
</div>
</div>
)
}
export default Introduction